module.exports = __webpack_public_path__ + "static/img/ge.36380dcf.svg";